<template>
  <div class="row position-relative mx-2 mt-2 mb-0 rounded">
    <a :href="item.bannerLink" target="_blank" ref="bannerLink">
      <img :src="item.bannerImage || item.backdropSmall" class="col-12 p-0 rounded">
    </a>
  </div>
</template>
<script>
export default {
  props: ['item', 'promoMode'],
  methods: {
    onItemClick () {
      this.$refs.bannerLink.click()
    }
  }
}
</script>
